import type { Form } from 'payments-lib-types';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormGroup } from '@/components/form/groups/FormGroup';
import { Input } from '@/components/form/Input';
import { validateEmail } from '@/helpers/validators';
import type { OfUnion } from '@/types/common';
import type { MethodField } from '../helpers';

export const FieldEmail: FC<
  OfUnion<MethodField>[Form.MethodFieldType.Email]
> = ({ fieldName, proposedValue, activeThemeMode }) => {
  const { t } = useTranslation('deposits');

  return (
    <FormGroup mode={activeThemeMode} title={t('fields.email')}>
      <Input
        initialValue={proposedValue}
        mode={activeThemeMode}
        name={fieldName}
        placeholder={t('fields.email')}
        type="email"
        validate={validateEmail}
      />
    </FormGroup>
  );
};
